import { BG_SCHEMA, BUTTON_SCHEMA, TEXT_SCHEMA, TITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const COVER_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'cover',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    bg: BG_SCHEMA('600'),
    'button-alignment': 'center',
    buttons: [BUTTON_SCHEMA()],
    title: TITLE_SCHEMA('Capa'),
    text: TEXT_SCHEMA('Texto'),
    'text-position': 'center',
    'text-position-vertical': 'center',
    logo: '',
    logo_alignment: 'center',
    logo_height: '100'
  }
}

export const beforeParseCover = target => {
  commonBeforeParseMethod(target)
}

export const COVER_SECTION = config => ({
  schema: COVER_SCHEMA(config),
  beforeParse: beforeParseCover
})
